import React, { useEffect, useState } from "react";
import * as XLSX from "xlsx";
import { MoreOutlined, DownOutlined, ReloadOutlined, DeleteRowOutlined } from "@ant-design/icons";
import { Dropdown, Menu } from "antd";
import {
  Button,
  Col,
  Input,
  Row,
  Select,
  Space,
  Table,
  DatePicker,
  Typography,
  Modal,
  Form,

  Flex,
  Tag,
  notification,
  Upload,
  Radio,
} from "antd";
import { CheckSquareOutlined } from "@ant-design/icons";


import {
  CalculatorOutlined,
  CloudDownloadOutlined,
  CloudUploadOutlined,
  DeleteOutlined,
  ImportOutlined,
  SyncOutlined,
  MinusSquareOutlined,
  MinusCircleOutlined,
} from "@ant-design/icons";
import { InterroComptaService } from "../Services/InterroComptaService";
import { AdherentsService } from "../Services/AdherentsService";
import { RetenueService } from "../Services/RetenueService";
import moment from "moment";
import dayjs from "dayjs";
import { TraitementService } from "../Services/TraitementService";
const { Title } = Typography;
const { Option } = Select;

const Retenue = () => {
  const [form] = Form.useForm();

  const interroComptService = new InterroComptaService();
  const traitementsoinsService = new TraitementService()
  const retenueService = new RetenueService();
  const adherentsService = new AdherentsService();
  const getSelectedYear = () => {
    const currentYear = new Date().getFullYear();
    return currentYear.toString();
  };
  const [isLoading, setIsLoading] = useState(false);
  const [loading, setLoading] = useState(false);
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
  const [paramData, setParamData] = useState([]);
  const [filterMode, setFilterMode] = useState("tout");
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [selectedCodesoc, setSelectedCodesoc] = useState(null);
  const [journalData, setJournalData] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [selectJournal, setSelectJournal] = useState("AA");
  const [selectedMonth, setSelectedMonth] = useState(
    dayjs().format("MM")
  );
  const [pageSize, setPageSize] = useState(10);
  const [isImportModalVisible, setIsImportModalVisible] = useState(false);
  const [importedData, setImportedData] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [comptaPreviewData, setComptaPreviewData] = useState([]);
  const [filteredTableData, setFilteredTableData] = useState([]);
  const [typeRapproche, setTypeRapproche] = useState("non");

  const fetchDataInit = async () => {
    const getParam = await traitementsoinsService.getParamComptable();
    setParamData(getParam);
    const yearFromParamData = dayjs(getParam.datedeb).format("YYYY");
    setSelectedYear(yearFromParamData)
    const currentMonth = dayjs().format("MM");
    setSelectedMonth(currentMonth);
    console.log(selectedMonth);

  };

  const currentYear = new Date().getFullYear();
  const lastFiveYears = Array.from({ length: 5 }, (_, i) => currentYear - i);

  useEffect(() => {

    fetchDataInit();
    return () => { };
  }, []);


  const fetchData = async () => {
    setIsLoading(true);
    try {
      const listData = await adherentsService.getAllAdherents();
      console.log(selectedMonth);

      setJournalData(listData);

      const data = await retenueService.getAllRetenue(
        selectedYear,
        selectedMonth,
        selectJournal
      );

      setTableData(data);
      await retenueService.getRetenue(
        selectedYear,
        selectedMonth,
        selectJournal
      );
    } catch (error) {
      console.error("Erreur lors de la récupération des données :", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (selectedYear) {
      fetchData();
    }

  }, [selectJournal, selectedMonth, selectedYear]);

  useEffect(() => { }, [journalData]);

  const handleSelectJournalChange = (value) => {
    console.log("Selected Journal:", value); // Pour débugger
    setSelectJournal(value);
  };

  useEffect(() => {
    setFilteredTableData(tableData);
  }, [tableData]);

  const handleYearChange = (value) => {
    setSelectedYear(value);
  };

  function formatNumber(number) {
    return new Intl.NumberFormat("fr-FR").format(number);
  };



  const fetchTableData = async () => {
    setIsLoading(true);
    try {
      const rapprochementData = await interroComptService.getRapprochement(
        selectedYear,
        selectedMonth,
        selectJournal
      );

      const postData = [...rapprochementData];
      const addResponse = await interroComptService.addRapprochement(postData);
      console.log("addRapprochement response:", addResponse);

      // Vérifie si l'ajout a été confirmé par le serveur
      if (addResponse && addResponse.Added) {
        const newData = await interroComptService.getListTable(
          typeRapproche,
          selectedYear,
          selectedMonth,
          selectJournal
        );

        // Mettre à jour l'état avec les nouvelles données qui doivent refléter l'état 'Ajout' à 'true'
        setTableData(newData);
      } else {
        console.error("addRapprochement failed or not added:", addResponse);
      }
    } catch (error) {
      console.error("Error during data fetch or update:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    const filteredData = tableData.filter(item => {
      if (selectJournal === "AA") {
        return true; // Pas de filtrage si "Toutes les sociétés" est sélectionné
      }
      return item.codesoc === selectJournal;
    });
    setFilteredTableData(filteredData);
  }, [selectJournal, tableData, selectedMonth, selectedYear]);

  const handleDelete = async () => {
    setIsLoading(true);
    try {
      const response = await interroComptService.deleteRetenue(
        selectedYear,
        selectedMonth,
        selectJournal
      );

      notification.success({
        message: "Suppression réussie",
        description:
          "Les retenues sélectionnées ont été supprimées avec succès.",
      });

      fetchData();
    } catch (error) {
      notification.error({
        message: "Erreur lors de la suppression",
        description:
          "Une erreur est survenue lors de la suppression des retenues.",
      });
    } finally {
      setIsLoading(false);
    }
  };

  const onSelectChange = (selectedKeys, selectedRowP) => {
    if (selectedRowP.length === 0) {
      // Si aucune ligne n'est sélectionnée, réinitialisez le selectedCodesoc
      setSelectedCodesoc(null);
      setSelectedRows([]);
      return;
    }

    const selectedCodesocValue = selectedRowP[0].codesoc;

    // Filtrer les lignes sélectionnées pour inclure toutes les lignes ayant le même codesoc
    const rowsWithSameCodesoc = tableData.filter(row => row.codesoc === selectedCodesocValue);

    setSelectedCodesoc(selectedCodesocValue);
    setSelectedRows(rowsWithSameCodesoc);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: (newSelectedRowKeys, selectedRows) => {
      setSelectedRowKeys(newSelectedRowKeys);
      setSelectedRows(selectedRows);
      // Si besoin, vous pouvez aussi gérer selectedCodesoc ici
      // setSelectedCodesoc(selectedRows.length > 0 ? selectedRows[0].codesoc : null);
    },
    // Si vous voulez désactiver la sélection selon une condition, décommentez ci-dessous :
    // getCheckboxProps: (record) => ({
    //   disabled: false, // ou votre logique de désactivation
    // }),
  };



  const isButtonDisabled = selectedRows.length === 0;

  const generateFileName = (
    selectedMonth,
    selectedYear,
    selectJournal,
    tableData,
    monthOptions
  ) => {
    const monthLabel = `Solde Frais Medicaux - ${monthOptions.find((m) => m.value === selectedMonth)?.label ||
      "Mois non sélectionné"
      }`;
    const journalLabel = getJournalLabel(selectJournal);
    const participantCount = tableData.length;
    return `${monthLabel} ${selectedYear} - ${journalLabel} (${participantCount} Participant).xlsx`;
  };

  const exportToExcel = (
    data,
    selectedMonth,
    selectedYear,
    selectJournal,
    tableData,
    monthOptions
  ) => {
    // Génération du nom du fichier
    const fileName = generateFileName(
      selectedMonth,
      selectedYear,
      selectJournal,
      tableData,
      monthOptions
    );

    // Mappage des noms des colonnes
    const mapColumns = (data) => {
      return data.map((row) => ({
        "Code Retenue": row.code_retenue,
        "Matricule": row.matricule,
        "Participant": row.part,
        "Code soc.": row.codesoc,
        "Solde": row.solde,
        "Retenue IPM": row.mont_retenue,
        "Retenue Paie": row.mont_retenue_soc,
        "Catégorie": row.categprof,
        "Statut": row.statut,
        "Matricule_Paie": row.matricule_paie,
      }));
    };

    // Mappage des données avec les nouveaux noms des colonnes
    const mappedData = mapColumns(data);

    // Création d'un nouveau classeur
    const workbook = XLSX.utils.book_new();
    // Conversion des données en feuille de travail
    const worksheet = XLSX.utils.json_to_sheet(mappedData);
    // Ajout de la feuille de travail au classeur
    XLSX.utils.book_append_sheet(workbook, worksheet, "Data");
    // Exportation du classeur (cela déclenchera le téléchargement)
    XLSX.writeFile(workbook, fileName);
  };
  const handleFilterChange = (e) => {
    const selectedMode = e.target.value;
    setFilterMode(selectedMode);

    // Filtrage en fonction des montants retenue
    if (selectedMode === "anomalies") {
      // Montants différents
      setFilteredTableData(
        tableData.filter((row) => row.mont_retenue !== row.mont_retenue_soc)
      );
    } else if (selectedMode === "normales") {
      // Montants égaux
      setFilteredTableData(
        tableData.filter((row) => row.mont_retenue === row.mont_retenue_soc)
      );
    } else {
      // Voir tout
      setFilteredTableData(tableData);
    }
  };



  const columns = [
    {
      title: "Code Retenue",
      dataIndex: "code_retenue",
      key: "code_retenue",
      align: "center",
      sorter: (a, b) => {
        if (!a.code_retenue && b.code_retenue) return 1;
        if (a.code_retenue && !b.code_retenue) return -1;
        if (!a.code_retenue && !b.code_retenue) return 0;
        return a.code_retenue.localeCompare(b.code_retenue);
      },
    },
    {
      title: "Matricule",
      dataIndex: "matricule",
      key: "matricule",
      align: "center",
      sorter: (a, b) => {
        if (!a.matricule && b.matricule) return 1;
        if (a.matricule && !b.matricule) return -1;
        if (!a.matricule && !b.matricule) return 0;
        return a.matricule.localeCompare(b.matricule);
      },
    },
    {
      title: "Participant",
      dataIndex: "part",
      key: "part",
      sorter: (a, b) => {
        if (!a.part && b.part) return 1;
        if (a.part && !b.part) return -1;
        if (!a.part && !b.part) return 0;
        return a.part.localeCompare(b.part);
      },
    },
    {
      title: "Code Soc",
      dataIndex: "codesoc",
      key: "codesoc",
      align: "center",
      sorter: (a, b) => {
        if (!a.codesoc && b.codesoc) return 1;
        if (a.codesoc && !b.codesoc) return -1;
        if (!a.codesoc && !b.codesoc) return 0;
        return a.codesoc.localeCompare(b.codesoc);
      },
    },
    {
      title: (
        <div
          style={{
            backgroundColor: "#010f1c",
            color: "white",
            paddingRight: 10,
          }}
        >
          Solde
        </div>
      ),
      dataIndex: "solde",
      key: "solde",
      align: "right",
      sorter: (a, b) => {
        const soldeA = a.solde ?? 0;
        const soldeB = b.solde ?? 0;
        return soldeA - soldeB;
      },
      render: (text) => (
        <div style={{ paddingRight: 10 }}>
          <strong>
            {formatNumber(text && parseFloat(text) !== 0 ? parseFloat(text) : "")}
          </strong>
        </div>
      ),
    },
    {
      title: (
        <div
          style={{
            backgroundColor: "#010f1c",
            color: "white",
            paddingRight: 10,
          }}
        >
          Retenue IPM
        </div>
      ),
      dataIndex: "mont_retenue",
      key: "mont_retenue",
      align: "right",
      sorter: (a, b) => {
        const retenueA = a.mont_retenue ?? 0;
        const retenueB = b.mont_retenue ?? 0;
        return retenueA - retenueB;
      },
      render: (text) => (
        <div style={{ paddingRight: 10 }}>
          <strong>
            {formatNumber(text && parseFloat(text) !== 0 ? parseFloat(text) : "")}
          </strong>
        </div>
      ),
    },
    {
      title: (
        <div
          style={{
            backgroundColor: "#010f1c",
            color: "white",
            paddingRight: 10,
          }}
        >
          Retenue Paie
        </div>
      ),
      dataIndex: "mont_retenue_soc",
      key: "mont_retenue_soc",
      align: "right",
      sorter: (a, b) => {
        const retenueSocA = a.mont_retenue_soc ?? 0;
        const retenueSocB = b.mont_retenue_soc ?? 0;
        return retenueSocA - retenueSocB;
      },
      render: (text) => (
        <div style={{ paddingRight: 10 }}>
          <strong>
            {formatNumber(text && parseFloat(text) !== 0 ? parseFloat(text) : "")}
          </strong>
        </div>
      ),
    },
    {
      title: "Écart",
      dataIndex: "ecart",
      key: "ecart",
      align: "right",
      render: (text, record) => {
        // Calcul de l'écart
        const ecartValue =
          (record.mont_retenue || 0) -
          (record.mont_retenue_soc || 0);
        return (
          <strong style={{ paddingRight: 16, color: ecartValue !== 0 ? "red" : "green" }}>
            {formatNumber(ecartValue)}
          </strong>
        );
      },
      sorter: (a, b) => {
        const ecartSocA = a.ecart ?? 0;
        const ecartSocB = b.ecart ?? 0;
        return ecartSocA - ecartSocB;
      },
    },
    {
      title: "État",
      dataIndex: "compta",
      key: "compta",
      align: "center",
      sorter: (a, b) => {
        if (!a.compta && b.compta) return 1;
        if (a.compta && !b.compta) return -1;
        if (!a.compta && !b.compta) return 0;
        return a.compta.localeCompare(b.compta);
      },
      render: (text) => (
        <Tag color={text === "Oui" ? "#4be000" : "#fc1303"}>
          {text === "Oui" ? "Comptabiliser" : "Non Comptabiliser"}
        </Tag>
      ),
    },
  ];


  const monthOptions = [
    // { value: "13", label: "Tous les mois" },
    { value: "01", label: "Janvier" },
    { value: "02", label: "Février" },
    { value: "03", label: "Mars" },
    { value: "04", label: "Avril" },
    { value: "05", label: "Mai" },
    { value: "06", label: "Juin" },
    { value: "07", label: "Juillet" },
    { value: "08", label: "Août" },
    { value: "09", label: "Septembre" },
    { value: "10", label: "Octobre" },
    { value: "11", label: "Novembre" },
    { value: "12", label: "Décembre" },
  ];

  const getJournalLabel = (code) => {
    // Trouve le journal correspondant par codej et retourne son libelle
    const journal = journalData.find((j) => j.codeadht === code);
    // Vérifie que journal existe et retourne la chaîne formatée avec codeadht et intitule
    return journal
      ? `${journal.codeadht} - ${journal.intitule}`
      : "Toutes";
  };

  const totalRetenue = filteredTableData.reduce(
    (sum, record) => sum + parseFloat(record.mont_retenue_soc || 0),
    0
  );
  const solde = filteredTableData.reduce(
    (sum, record) => sum + parseFloat(record.solde || 0),
    0
  );

  const refreshData = () => {
    fetchData();
  };
  const handleSearch = (value) => {
    const filtered = tableData.filter((item) =>
      Object.values(item).some(
        (val) =>
          val && val.toString().toLowerCase().includes(value.toLowerCase())
      )
    );
    setFilteredTableData(filtered); // Assurez-vous que cette logique de filtrage est correcte
  };

  const handleClick = () => {
    setIsModalVisible(true);
  };

  const handleDeleteSelected = () => {
    if (selectedRowKeys.length === 0) return;

    // Vérifie si une des lignes sélectionnées est comptabilisée
    const hasComptaOui = filteredTableData
      .filter(row => selectedRowKeys.includes(`${row.code_retenue}-${row.matricule}`))
      .some(row => row.compta === "Oui");

    if (hasComptaOui) {
      Modal.warning({
        title: "Suppression impossible",
        content: "Impossible de supprimer une ligne déjà comptabilisée.",
        okText: "Fermer",
      });
      return;
    }

    Modal.confirm({
      title: "Confirmation",
      content: "Voulez-vous supprimer les lignes sélectionnées ?",
      okText: "Oui",
      cancelText: "Annuler",
      onOk: async () => {
        // Suppression locale (coté front)
        const newData = tableData.filter(
          row => !selectedRowKeys.includes(`${row.code_retenue}-${row.matricule}`)
        );
        setTableData(newData);
        setFilteredTableData(newData);
        setSelectedRowKeys([]);
        setSelectedRows([]);
        // Si besoin, appeler ici la suppression côté serveur
        await retenueService.deleteRetenue(selectedRowKeys);
        console.log(selectedRowKeys);

        notification.success({ message: "Suppression effectuée" });
      }
    });
  };

  const actionMenu = (
    <Menu>
      <Menu.Item key="refresh" onClick={refreshData} icon={<ReloadOutlined />}>
        Actualiser
      </Menu.Item>
      <Menu.Item
        key="delete"
        onClick={handleDeleteSelected}
        icon={<DeleteRowOutlined />}
        disabled={selectedRowKeys.length === 0} // Désactive si aucune sélection
        style={selectedRowKeys.length === 0 ? { color: "#e61a1aff", cursor: "not-allowed" } : {}}
      >
        Supprimer la sélection
      </Menu.Item>
    </Menu>
  );

  // Dropdown Sélection (Tout sélectionner / Tout désélectionner)
  const selectionMenu = (
    <Menu>
      <Menu.Item
        key="selectAll"
        icon={<CheckSquareOutlined />}
        onClick={() => setSelectedRowKeys(filteredTableData.map(row => `${row.code_retenue}-${row.matricule}`))}
      >
        <span className="menu-item-text">Tout Sélectionner</span>
      </Menu.Item>
      <Menu.Item
        key="deselectAll"
        icon={<MinusSquareOutlined />}
        onClick={() => setSelectedRowKeys([])}
      >
        <span className="menu-item-text">Tout Désélectionner</span>
      </Menu.Item>
    </Menu>
  );

  const menuStyles = {
    ".menu-item-text": {
      marginLeft: "0.5rem",
    },
  };

  const handleModalOk = async () => {
    if (selectedYear && selectedMonth && selectJournal) {
      setIsLoading(true);
      try {
        const data = await retenueService.addRetenue(
          selectedYear,
          selectedMonth,
          selectJournal
        );
        notification.success({
          message: "ajout réussie",
          description: "Appel retenue effectué avec succès.",
        });
        fetchData();
        setIsModalVisible(false);
      } catch (error) {
        notification.error({
          message: "Erreur lors de l'appel retenue",
        });
      } finally {
        setIsLoading(false);
      }
    }
  };

  const handleModalCancel = () => {
    setIsModalVisible(false);

    form.resetFields();
  };

  const handleComptabiliser = async () => {
    try {
      const selectedRows = [...tableData];

      const data = await retenueService.addPreviewRetenuCompta(selectedRows);
      setComptaPreviewData(data);
      setIsModalOpen(true);
    } catch (error) {
      console.error(
        "Erreur lors de la récupération des données comptables :",
        error
      );
    }
  };


  const isTableEmpty = filteredTableData.length === 0;
  const handleExcelImport = (file) => {
    setLoading(true); // Active le loading
    const reader = new FileReader();

    try {

      reader.onload = (e) => {
        const data = e.target.result;
        const workbook = XLSX.read(data, { type: "binary" });
        const sheetName = workbook.SheetNames[0];
        const sheet = workbook.Sheets[sheetName];
        const parsedData = XLSX.utils.sheet_to_json(sheet, { header: 1 });

        const keys = parsedData[0];
        const rows = parsedData.slice(1).map((row) => {
          let obj = {};
          row.forEach((cell, i) => {
            obj[keys[i]] = cell;
          });
          return obj;
        });

        setImportedData(rows);
      };
      reader.readAsBinaryString(file);
      return false;
    } catch (error) {
      error.message("Erreur lors de l'import du fichier");
      console.error(error);
    } finally {
      setLoading(false);

    }

  };

  const columns1 = [
    {
      title: "Code Retenue",
      dataIndex: "Code Retenue",
      key: "code_retenue",
      align: "center",
    },
    {
      title: "Matricule",
      dataIndex: "Matricule",
      key: "matricule",
      align: "center",
    },
    { title: "Participant", dataIndex: "Participant", key: "part" },
    {
      title: "Code soc.",
      dataIndex: "Code soc.",
      key: "codesoc",
      align: "center",
    },
    {
      title: "Solde",
      dataIndex: "Solde",
      key: "solde",
      align: "right",
      render: (text) => (
        <div style={{ paddingRight: 5 }}>{formatNumber(parseFloat(text))}</div>
      ),
    },
    {
      title: "Retenue IPM",
      dataIndex: "Retenue IPM",
      key: "mont_retenue",
      align: "right",
      render: (text) => (
        <div style={{ paddingRight: 5 }}>{formatNumber(parseFloat(text))}</div>
      ),
    },
    {
      title: "Retenue Paie",
      dataIndex: "Retenue Paie",
      key: "mont_retenue_soc",
      align: "right",
      render: (text) => (
        <div style={{ paddingRight: 5 }}>{formatNumber(parseFloat(text))}</div>
      ),
    },
  ];

  const totalMontantRet = importedData.reduce(
    (sum, record) => sum + parseFloat(record["Retenue Paie"] || 0),
    0
  );
  const exportToExcel2 = (data, fileName) => {
    const ws = XLSX.utils.json_to_sheet(data);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
    XLSX.writeFile(wb, `${fileName}.xlsx`);
  };

  const prepareDataForExport = (data) => {
    return data.map((row) => ({
      CodeJ: row.codej,
      DateCompta: row.datecompta,
      MoisTrait: row.datetrait,
      NumPiece: row.numpiece,
      NumCheque: row.numcheque,
      NumFIPM: row.numfactipm,
      CompteGen: row.comptegen,
      CompteTiers: row.comptetiers,
      Matricule: row.matri,
      Libelle: row.libelle,
      Debit: row.debit,
      Credit: row.credit,
    }));
  };

  const handleValidCompta = async () => {
    try {
      const selectedRows = [...tableData];
      const payload = {
        comptas: comptaPreviewData,
        retenues: selectedRows,
      };
      const data = await retenueService.addValidRetenueCompta(payload);
      fetchData();
      setIsModalOpen(false);
    } catch (error) {
      console.error(
        "Erreur lors de la récupération des données comptables :",
        error
      );
    }
  };


  const columns2 = [
    {
      title: "C.JL",
      dataIndex: "codej",
      key: "codej",
      align: "center",
      sorter: (a, b) => (a.codej || "").localeCompare(b.codej || ""),
    },
    {
      title: "D. Compta",
      dataIndex: "datecompta",
      key: "datecompta",
      align: "center",
      sorter: (a, b) =>
        (a.datecompta ? moment(a.datecompta).unix() : 0) -
        (b.datecompta ? moment(b.datecompta).unix() : 0),
      render: (text) => (
        <div>{text ? moment(text).format("DD/MM/YYYY") : ""}</div>
      ),
    },
    {
      title: "Mois trait.",
      dataIndex: "datetrait",
      key: "datetrait",
      align: "center",
      sorter: (a, b) =>
        (a.datetrait ? moment(a.datetrait).unix() : 0) -
        (b.datetrait ? moment(b.datetrait).unix() : 0),
      render: (text) => (
        <div>{text ? moment(text).format("MMM.YYYY") : ""}</div>
      ),
    },
    {
      title: "N° pièce",
      dataIndex: "numpiece",
      key: "numpiece",
      align: "center",
      sorter: (a, b) => (a.numpiece || "").localeCompare(b.numpiece || ""),
    },
    {
      title: "N° Chèque",
      dataIndex: "numcheque",
      key: "numcheque",
      align: "center",
      sorter: (a, b) => (a.numcheque || "").localeCompare(b.numcheque || ""),
    },
    {
      title: "N° F. IPM",
      dataIndex: "numfactipm",
      key: "numfactipm",
      align: "center",
      sorter: (a, b) => (a.numfactipm || "").localeCompare(b.numfactipm || ""),
    },
    {
      title: "Cpte. Gen.",
      dataIndex: "comptegen",
      key: "comptegen",
      align: "center",
      sorter: (a, b) => (a.comptegen || "").localeCompare(b.comptegen || ""),
    },
    {
      title: "Cpte. Tiers",
      dataIndex: "comptetiers",
      key: "comptetiers",
      align: "center",
      sorter: (a, b) => (a.comptetiers || "").localeCompare(b.comptetiers || ""),
    },
    {
      title: "Matricule",
      dataIndex: "matri",
      key: "matri",
      align: "center",
      sorter: (a, b) => (a.matri || "").localeCompare(b.matri || ""),
    },
    {
      title: "Libellé",
      dataIndex: "libelle",
      key: "libelle",
      sorter: (a, b) => (a.libelle || "").localeCompare(b.libelle || ""),
    },
    {
      title: "Débit",
      dataIndex: "debit",
      key: "debit",
      align: "right",
      sorter: (a, b) => (a.debit || 0) - (b.debit || 0),
      render: (text) => (
        <div style={{ paddingRight: 5 }}>
          {text && parseFloat(text) !== 0 ? formatNumber(parseFloat(text)) : ""}
        </div>
      ),
    },
    {
      title: "Crédit",
      dataIndex: "credit",
      key: "credit",
      align: "right",
      sorter: (a, b) => (a.credit || 0) - (b.credit || 0),
      render: (text) => (
        <div style={{ paddingRight: 5 }}>
          {text && parseFloat(text) !== 0 ? formatNumber(parseFloat(text)) : ""}
        </div>
      ),
    },
  ];

  const totalDebit1 = comptaPreviewData.reduce(
    (sum, record) => sum + parseFloat(record.debit || 0),
    0
  );
  const totalCredit1 = comptaPreviewData.reduce(
    (sum, record) => sum + parseFloat(record.credit || 0),
    0
  );
  const solde1 = totalDebit1 - totalCredit1;

  const handleImport = async () => {
    try {
      const payload = importedData.map((data) => ({
        code_retenue: data["Code Retenue"],
        codesoc: data["Code soc."],
        matricule: data["Matricule"],
        mont_retenue: data["Retenue IPM"],
        mont_retenue_soc: data["Retenue Paie"],
        part: data["Participant"],
        solde: data["Solde"],
      }));

      const response = await retenueService.importRetenue(payload);
      setIsImportModalVisible(false);
      notification.success({
        message: "Importation réussie",
        description: "Les données ont été importées avec succès.",
      });
      fetchData();
    } catch (error) {
      notification.error({
        message: "Erreur lors de l'importation",
        description:
          "Une erreur est survenue lors de l'importation des données.",
      });
    }
  };


  const isComptaDisabled = !filteredTableData.some(
    (row) => row.compta !== "Oui"
  );

  const isAppelRetenuDisabled = tableData.length > 0;

  return (
    <div>
      <Row gutter={16} style={{ padding: 12 }}>
        <Col xs={24} sm={24} md={8} lg={8} xl={8}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 12,
              padding: "10px 20px",
              background: "linear-gradient(135deg, #1890ff 0%, #0097e6 100%)",
              borderRadius: 10,
              boxShadow: "0 4px 15px rgba(24, 144, 255, 0.3)",
            }}
          >
            <MinusCircleOutlined style={{ fontSize: 22, color: "#fff" }} />
            <span
              style={{
                fontSize: 18,
                fontWeight: 600,
                color: "#fff",
                letterSpacing: 0.5,
                margin: 0,
              }}
            >
              Retenues Frais Médicaux
            </span>
          </div>
          <p>
            <strong>
              {" "}
              {monthOptions.find((m) => m.value === selectedMonth)?.label ||
                "Mois non sélectionné"}{" "}
              {selectedYear} {/* {` ${getJournalLabel(selectJournal)}`} */} (
              {tableData.length} Participant)
            </strong>
            <br />
            <Space>
              <span>
                <strong> Total Solde : {formatNumber(solde)}</strong>
              </span>
              <span>
                <strong>Total Retenue : {formatNumber(totalRetenue)}</strong>
              </span>
            </Space>
          </p>
        </Col>

        <Col xs={24} sm={24} md={16} lg={16} xl={16}>
          <Row gutter={16}>
            <Col xs={24} sm={24} md={8} lg={8} xl={5}>
              <Input
                placeholder="Recherche..."
                bordered={false}
                style={{
                  borderBottom: "2px solid black",
                  width: "100%",
                  paddingTop: 6,
                }}
                onChange={(e) => handleSearch(e.target.value)}
                onPressEnter={(e) => handleSearch(e.target.value)}
              />
            </Col>
            <Col xs={24} sm={24} md={8} lg={8} xl={11}>
              <Select
                bordered={false}
                style={{ borderBottom: "2px solid #030303", width: "100%" }}
                value={selectJournal}
                onChange={handleSelectJournalChange}
                showSearch
                filterOption={(input, option) =>
                  option.children
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
                }
              >
                <Option value="AA">Toutes les sociétés</Option>
                {journalData.map((journal) => (
                  <Option key={journal.codeadht} value={journal.codeadht}>
                    {`${journal.codeadht} - ${journal.intitule}`}
                  </Option>
                ))}
              </Select>
            </Col>
            <Col xs={24} sm={24} md={8} lg={8} xl={4}>
              <Select
                bordered={false}
                style={{ borderBottom: "2px solid #030303", width: "100%" }}
                onChange={handleYearChange}
                value={selectedYear}
              >
                {lastFiveYears.map(year => (
                  <Select.Option key={year} value={String(year)}>
                    {year}
                  </Select.Option>
                ))}
              </Select>
            </Col>
            <Col xs={24} sm={24} md={8} lg={8} xl={4}>
              <Select
                bordered={false}
                style={{ borderBottom: "2px solid #030303", width: "100%" }}
                onChange={setSelectedMonth}
                value={selectedMonth}

              >
                {monthOptions.map((month) => (
                  <Option key={month.value} value={month.value}>
                    {month.label}
                  </Option>
                ))}
              </Select>
            </Col>
          </Row>
        </Col>
      </Row>

      <Row gutter={16}>
        <Col
          xs={24}
          sm={24}
          md={12}
          lg={12}
          xl={4}
          style={{ display: "flex", justifyContent: "end", marginBottom: 16 }}
        ></Col>
        <Col
          xs={24}
          sm={24}
          md={12}
          lg={12}
          xl={20}
          style={{ display: "flex", justifyContent: "end", marginBottom: 16 }}
        >
          <Flex wrap="wrap" gap="small">
            <Dropdown overlay={selectionMenu} trigger={["click"]}>
              <Button
                style={{
                  backgroundColor: "#a8b156ff",
                  ":hover": { color: "white" },
                }}
              >
                Sélection <DownOutlined />
              </Button>
            </Dropdown>
            <Button
              style={{ background: "#024012", color: "white" }}
              onClick={handleClick}
              disabled={isAppelRetenuDisabled}
            >
              Appel Retenue
              <CloudUploadOutlined />
            </Button>
            <Button
              icon={<CalculatorOutlined />}
              className="buttonCompta"
              disabled={isTableEmpty || isComptaDisabled || totalRetenue === 0}
              onClick={handleComptabiliser}
            >
              Comptabiliser
            </Button>

            <Button
              className="buttonExport"
              onClick={() =>
                exportToExcel(
                  filteredTableData,
                  selectedMonth,
                  selectedYear,
                  selectJournal,
                  tableData,
                  monthOptions
                )
              }
              icon={<CloudDownloadOutlined />}
              disabled={isTableEmpty}
            >
              Export Excel
            </Button>

            <Button
              className="buttonImport"
              disabled={isTableEmpty || isComptaDisabled}
              icon={<ImportOutlined />}
              onClick={() => setIsImportModalVisible(true)}
            >
              Import Excel
            </Button>
            <div style={{ display: "flex", gap: 8, marginLeft: 16 }}>
              {[
                { value: "tout", label: "Voir tout" },
                { value: "anomalies", label: "Anomalies" },
                { value: "normales", label: "Normales" },
              ].map((item) => (
                <button
                  key={item.value}
                  onClick={() => handleFilterChange({ target: { value: item.value } })}
                  style={{
                    padding: "6px 14px",
                    borderRadius: 20,
                    border: "none",
                    cursor: "pointer",
                    fontSize: 13,
                    fontWeight: 500,
                    transition: "all 0.3s ease",
                    background: filterMode === item.value
                      ? "linear-gradient(135deg, #1890ff 0%, #0097e6 100%)"
                      : "#f0f0f0",
                    color: filterMode === item.value ? "#fff" : "#595959",
                    boxShadow: filterMode === item.value
                      ? "0 3px 10px rgba(24, 144, 255, 0.4)"
                      : "0 1px 3px rgba(0, 0, 0, 0.1)",
                  }}
                  onMouseEnter={(e) => {
                    if (filterMode !== item.value) {
                      e.currentTarget.style.background = "#e0e0e0";
                      e.currentTarget.style.transform = "translateY(-1px)";
                    }
                  }}
                  onMouseLeave={(e) => {
                    if (filterMode !== item.value) {
                      e.currentTarget.style.background = "#f0f0f0";
                      e.currentTarget.style.transform = "translateY(0)";
                    }
                  }}
                >
                  {item.label}
                </button>
              ))}
            </div>

            <Dropdown overlay={actionMenu} trigger={["click"]}>
              <Button icon={<MoreOutlined />} />
            </Dropdown>
          </Flex>
        </Col>
      </Row>

      <Table
        id="retenues-table"
        row
        loading={isLoading}
        scroll={{ x: true }}
        className="custom-header1-table"
        style={{ cursor: "pointer", whiteSpace: "nowrap", width: "100%" }}
        bordered
        pagination={{
          pageSizeOptions: ["5", "10", "20", "50", "100"], // Options disponibles pour la pagination
          showSizeChanger: true, // Permet à l'utilisateur de changer le nombre de lignes par page
          pageSize: pageSize, // Valeur actuelle du nombre de lignes par page
          onShowSizeChange: (current, size) => setPageSize(size), // Mise à jour de pageSize lors du changement
        }}
        showSorterTooltip={false}
        dataSource={filteredTableData}
        rowSelection={rowSelection}
        columns={columns}
        rowKey={record => `${record.code_retenue}-${record.matricule}`}
      />

      <Modal
        title="Appel Retenue Frais Médicaux"
        open={isModalVisible}
        onOk={handleModalOk}
        onCancel={handleModalCancel}
        width={800}
        style={{ top: 20 }}
        maskClosable={false}
        footer={[
          <Button key="back" onClick={handleModalCancel}>
            Annuler
          </Button>,
          <Button
            key="submit"
            className="Buttonvalid"
            onClick={handleModalOk}
            loading={isLoading} // Ajoute le spinner de chargement
          >
            {isLoading ? 'Chargement...' : 'Valider'}
          </Button>,
        ]}
      >
        <Form form={form} layout="vertical">
          <Form.Item>
            <Select
              bordered={false}
              style={{ marginRight: 10, borderBottom: "2px solid #030303" }}
              onChange={handleYearChange}
              value={selectedYear}
            >
              <Select.Option value="2023">2023</Select.Option>
              <Select.Option value="2024">2024</Select.Option>
            </Select>
          </Form.Item>
          <Form.Item>
            <Select
              bordered={false}
              style={{ borderBottom: "2px solid #030303" }}
              onChange={setSelectedMonth}
              value={selectedMonth}
            >
              {monthOptions.map((month) => (
                <Option key={month.value} value={month.value}>
                  {month.label}
                </Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item
            name="codesoc"
            label="Société"
            initialValue={selectJournal}
          >
            <Select
              showSearch
              bordered={false}
              style={{ borderBottom: "1px solid black" }}
              value={selectJournal}
            >
              <Option value="AA">Toutes les sociétés</Option>
              {journalData.map((journal) => (
                <Option key={journal.codeadht} value={journal.codeadht}>
                  {journal.codeadht} - {journal.intitule}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </Form>
      </Modal>
      <Modal
        //
        title="Importation Retenues Frais Médicaux"
        open={isImportModalVisible}
        onCancel={() => setIsImportModalVisible(false)}
        footer={[
          <Button key="cancel" onClick={() => setIsImportModalVisible(false)}>
            Annuler
          </Button>,
          <Button key="import" type="primary" onClick={handleImport}>
            Importer
          </Button>,
        ]}
        width={800}
      >
        <Upload beforeUpload={handleExcelImport} accept=".xlsx, .xls"
          disabled={loading} // Désactive l'upload pendant le chargement
        >
          <Button
            style={{ marginBottom: "16px" }}
            icon={<CloudUploadOutlined />}
          >
            Sélectionner un fichier
          </Button>
        </Upload>
        <Table
          loading={loading}
          scroll={{ x: true, y: 400 }}
          className="custom-header1-table"
          style={{ cursor: "pointer", whiteSpace: "nowrap", width: "100%" }}
          showSorterTooltip={false}
          dataSource={importedData}
          columns={columns1}
          pagination={false}
          rowKey={record => `${record.code_retenue}-${record.matricule}`}
          bordered
        />
        <div style={{ marginTop: 16, alignContent: "right " }}>
          <Space>
            Total Participants : {importedData.length} - Total Montant:{" "}
            {formatNumber(totalMontantRet)}
          </Space>
        </div>
      </Modal>
      <Modal
        title="Aperçu écritures au journal"
        open={isModalOpen}
        onCancel={() => setIsModalOpen(false)}
        maskClosable={false}
        footer={[
          <Button
            className="buttonExport"
            onClick={() =>
              exportToExcel2(
                prepareDataForExport(comptaPreviewData),
                "AperçuEcritureJournalExport.xlsx"
              )
            }
          >
            Export
          </Button>,
          <Button
            key="back"
            className="buttonClose"
            onClick={() => setIsModalOpen(false)}
          >
            Fermer
          </Button>,
          <Button
            className="Buttonvalid"
            // disabled={solde1 !== 0}
            onClick={handleValidCompta}
          >
            Valider
          </Button>,
        ]}
        width={1200}
        style={{ top: 20 }}
      >
        <Input
          placeholder="Recherche..."
          bordered={false}
          style={{
            borderBottom: "2px solid #030303",
            width: "20%",
            marginBottom: 30,
          }}
        />
        <Table
          scroll={{
            x: true,
          }}
          className="custom-header1-table"
          style={{ cursor: "pointer", whiteSpace: "nowrap", width: "100%" }}
          bordered
          showSorterTooltip={false}
          dataSource={comptaPreviewData}
          columns={columns2}
          footer={() => (
            <div style={{ textAlign: "right" }}>
              <Space>
                <strong>Total Débit : {formatNumber(totalDebit1)}</strong>
                <strong>Total Crédit : {formatNumber(totalCredit1)}</strong>
                <strong> Solde : {formatNumber(solde1)}</strong>
              </Space>
            </div>
          )}
        />
      </Modal>
    </div>
  );
};

export default Retenue;
